import { render, staticRenderFns } from "./halogenalkane.vue?vue&type=template&id=2d4a2080&"
import script from "./halogenalkane.vue?vue&type=script&lang=js&"
export * from "./halogenalkane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports